import { render, staticRenderFns } from "./MemberRights.vue?vue&type=template&id=62abb794"
import script from "./MemberRights.vue?vue&type=script&lang=ts"
export * from "./MemberRights.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports